import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: '',
}

export const blockEditSlice = createSlice({
    name: 'isBlockEdit',
    initialState,
    reducers: {
        enable: (state, action) => {
            state.value = action.payload;
        },
        disable: (state, action) => {
            state.value = '';
        },
    },
})

export const { disable, enable } = blockEditSlice.actions

export default blockEditSlice.reducer